<template>
  <div>
    <form class="mt-2" id="form-modal">
      <!-- description Notes -->
      <div class="form-group">
        <label class="label-form">Next Followup Date:</label>
        <input class="form-control" id="followup_date" v-model="followup_date" type="datetime-local" />
        <br />
        <label class="label-form">Comment:</label>
        <textarea class="form-control" style="height: 200px" v-model="lead_note"
          placeholder="Comment here for this Demo">
        </textarea>
      </div>

      <!-- buttons -->
      <div class="form-footer text-right">
        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
          Close
        </button>
        <button type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-success btn-sm ml-1" @click="save">
            <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; position: absolute; right: 40%; margin-top: 3px;" />
          Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";
  import moment from "moment";
  export default {
    props: ["action", "formData"],
    data: function () {
      return {
        lead_note: "",  
        isMiniLoading: false,
        followup_date: "",
      };
    },
    created: function () {
      this.lead_note = "";
      let d = new Date().toLocaleString("en-US", { timeZone: "US/Eastern" });
      let date = new Date(d);
      this.followup_date = moment(date.setDate(date.getDate() + 2)).format('YYYY-MM-DDThh:mm');
    },
    methods: {
      save() {
        this.isMiniLoading= true;
        let lead_note = this.lead_note;
        let demo_id = this.formData.id;
        let followup_date = this.followup_date;
        let page_no = this.formData.page_no;
        let completion_date = new Date().toISOString().slice(0, 10);
        if (followup_date != "") {
          this.SetFollowupDate(followup_date,  this.formData.demo_id);
             const permission = {
      headers: {
        'X-Permission': 'lead_set_demo_date' 
      }
    };
          axios.post("/admin/users/complete-demo-note", {
              demo_id: demo_id,
              completion_date: completion_date,
              completion_note: lead_note,
              status: 1,
            },permission)
            .then(() => {
              this.isMiniLoading = true;
              this.$toast.success("Demo Completed successfully");
              window.$("#modal").modal("hide");
              this.$store.dispatch("users/getAllDemoRequests", [
                page_no,
                "",
                this.formData.status,
                "",
                "",
                "",
                "",
                "",
                "",
                this.formData.color ? this.formData.color : "",
                'all',
                'all',
                'all',
              ]);
            })
            .catch((error) => {
              this.isMiniLoading = true;
              this.$toast.error(error);
            });
        } else {
          this.isMiniLoading = true;
          this.$toast.warning("Please Fill All Required Fields");
        }
      },
      SetFollowupDate(followup_date, demo_id) {
          const permission = {
      headers: {
        'X-Permission': 'lead_set_followup_date' 
      }
    };
        axios.post("/admin/users/change-followup-date", {
          date: followup_date,
          id: demo_id,
        },permission);
      },
    },
  };
</script>